import {
  UPDATE_EDUCATION_TYPE,
  UPDATE_OTHER_USE_CASE,
  UPDATE_USE_CASES,
  UPDATE_WELCOME,
  UPDATE_WELCOME_COMPANY,
  UPDATE_WELCOME_COMPANY_SIZE,
  UPDATE_WELCOME_COMPLETE,
  UPDATE_WELCOME_HELP_OPTIONS,
  UPDATE_WELCOME_INDUSTRY,
  UPDATE_WELCOME_MANAGEMENT_LEVEL,
  UPDATE_WELCOME_ROLE,
  UPDATE_WELCOME_STEP,
  UPDATE_WELCOME_USE_CASE_PLAN,
} from 'constants/actions';

export const updateEducationType = educationType => {
  return {
    type: UPDATE_EDUCATION_TYPE,
    educationType,
  };
};

export const updateOtherUseCase = otherUseCase => {
  return {
    type: UPDATE_OTHER_USE_CASE,
    otherUseCase,
  };
};

export const updateUseCases = useCases => {
  return {
    type: UPDATE_USE_CASES,
    useCases,
  };
};

export const updateWelcome = welcomeState => {
  return {
    type: UPDATE_WELCOME,
    welcomeState,
  };
};

export const updateWelcomeCompany = company => {
  return {
    type: UPDATE_WELCOME_COMPANY,
    company,
  };
};

export const updateWelcomeComplete = complete => {
  return {
    type: UPDATE_WELCOME_COMPLETE,
    complete,
  };
};

export const updateWelcomeCompanySize = companySize => {
  return {
    type: UPDATE_WELCOME_COMPANY_SIZE,
    companySize,
  };
};

export const updateWelcomeIndustry = companyIndustry => {
  return {
    type: UPDATE_WELCOME_INDUSTRY,
    companyIndustry,
  };
};

export const updateWelcomeRole = (role, custom_role) => {
  return {
    type: UPDATE_WELCOME_ROLE,
    role,
    custom_role,
  };
};

export const updateWelcomeManagementLevel = management_level => {
  return {
    type: UPDATE_WELCOME_MANAGEMENT_LEVEL,
    management_level,
  };
};

export const updateWelcomeStep = step => {
  return {
    type: UPDATE_WELCOME_STEP,
    step,
  };
};

export const updateWelcomeUseCasePlan = useCasePlan => {
  return {
    type: UPDATE_WELCOME_USE_CASE_PLAN,
    useCasePlan,
  };
};

export const updateWelcomeHelpOptions = helpOptions => {
  return {
    type: UPDATE_WELCOME_HELP_OPTIONS,
    helpOptions,
  };
};
